import { z } from 'zod';

import {
  GlobalMaterialDtoSchema,
  GlobalMaterialPriceVersionRowSchema,
  MaterialOverrideDtoSchema,
  MaterialPriceOverrideVersionRowSchema,
} from '../materials-catalog/index.js';
import {
  MaterialCategoryConfigDocumentSchema,
  MaterialOrderingConfigDocumentSchema,
} from '../materials-presentation/index.js';
import type {
  MaterialsCatalogSyncItems,
  MaterialsCatalogSyncPullRequest,
  MaterialsCatalogSyncPullResponse,
} from './materials-catalog-sync.dto.js';

const timestampSchema = z.iso.datetime();

export const MaterialsCatalogSyncItemsSchema: z.ZodType<MaterialsCatalogSyncItems> = z.object({
  globalMaterials: z.array(GlobalMaterialDtoSchema),
  overrides: z.array(MaterialOverrideDtoSchema),
  globalPriceVersions: z.array(GlobalMaterialPriceVersionRowSchema),
  overridePriceVersions: z.array(MaterialPriceOverrideVersionRowSchema),
  companyOrdering: MaterialOrderingConfigDocumentSchema.nullable(),
  companyCategories: MaterialCategoryConfigDocumentSchema.nullable(),
});

export const MaterialsCatalogSyncPullRequestSchema: z.ZodType<MaterialsCatalogSyncPullRequest> =
  z.object({
    cursor: z.string().trim().min(1).nullable().optional(),
  });

export const MaterialsCatalogSyncPullResponseSchema: z.ZodType<MaterialsCatalogSyncPullResponse> =
  z.object({
    items: MaterialsCatalogSyncItemsSchema,
    nextCursor: z.string().trim().min(1).nullable(),
    serverTime: timestampSchema,
  });
